export function LoadingFallback() {
  return (
    <div
      className="flex h-[calc(100vh-64px)] w-full items-center justify-center"
      role="status"
      data-testid="loading-fallback"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}
